module.exports = __webpack_public_path__ + "static/media/6.4b3204a9.jpg";